/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./teleport.defs.js";
export { main as default } from "./teleport.defs.js";
